import routes from './routes';
import { SetRoutes } from 'components';

const StoreEventsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default StoreEventsPages;
